
import { defineComponent } from 'vue';
import { mapActions, mapGetters } from 'vuex';
import { OrganizationService } from './organization.service';
import { ToastFactory } from '@/utils/ToastFactory';
const orgService = new OrganizationService();

export default defineComponent({
    name: 'Organizations',
    data(){
        return {
            organizationTotal: 0,
            organizations: [],
            params:{ name: "", page: 0, size: 6, total: 0 },
            filters: null as any,
            status: ['Ativa', 'Aguardando ativação', 'Bloqueada', 'Desativada'],
            userRole: '' as string,
        }
    },

    computed: {
        ...mapGetters({
            storeOrganizations: "orgs/getOrganizations",
        }),
    },

    methods:{
        paginate(event: {page: number, rows: number}): void {
            this.getOrganizations(this.params.name, event.page, event.rows)
        },

        getOrganizations(name: string, page: number, size: number){
            orgService.getOrganizations({name, page, size}).then(() => {
                this.organizations = this.storeOrganizations.content;
                this.params.total = this.storeOrganizations.total;
            });
        },

        getAllOrgsDatabase(page: number, size: number){
            orgService.getOrganizations({page, size}).then(() => {
                this.organizationTotal = this.storeOrganizations.total;
            });
        },

        organizationsPaginate(): void {
            const page = this.params.page;
            const size = this.params.size;
            const name = this.params.name;
            this.getOrganizations(name, page, size);
        },

        updateStatus(id: string){
            orgService.updateStatus(id).then(() => {
                this.organizationsPaginate();
            });
        },

        deleteOrganization(id: any){
            orgService.deleteOrganization(id).then(() => {
                this.organizationsPaginate();
                this.getAllOrgsDatabase(this.params.page, this.params.size);
                this.$toast.add(ToastFactory.success(this.$t('toast.sucessOrgDelete')));
            }).catch((err) => {
                console.log(err);
                this.$toast.add(ToastFactory.error(this.$t('toast.errorOrgDelete')));
            });
        },

        confirmDelete(id: any){
            this.$confirm.require({
                header: this.$t('org.delete'),
                message: this.$t('org.confirmDelete'),
                accept: () => {
                    this.deleteOrganization(id);
                },
                reject: () => {
                    console.log('reject');
                }
            });
        },

        isActive(status: string){
            switch (status) {
                case 'ACTIVATED':
                    return navigator.language === 'pt-BR' ? 'Ativa' : 'Active';
                case 'WAITING_ACTIVATION':
                    return navigator.language === 'pt-BR' ? 'Aguardando ativação' : 'Waiting activation';
                case 'BLOCKED':
                    return navigator.language === 'pt-BR' ? 'Bloqueada' : 'Blocked';
                case 'INACTIVATED':
                    return navigator.language === 'pt-BR' ? 'Desativada' : 'Inactive';
                default:
                    return navigator.language === 'pt-BR' ? 'Desativada' : 'Inactive';
            }
        },
    },

    mounted(){
        this.organizationsPaginate();
        this.getAllOrgsDatabase(this.params.page, this.params.size);
    },

});
